import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-8 mt-12 text-muted-foreground text-sm">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-foreground">Cricket Scoring</h3>
            <p>
              A modern cricket scoring application for tournaments, teams, and matches with live updates and statistics.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="text-md font-semibold text-foreground">Quick Links</h4>
            <ul className="space-y-1">
              <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/features" className="hover:text-primary transition-colors">Features</Link></li>
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="text-md font-semibold text-foreground">Legal</h4>
            <ul className="space-y-1">
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/disclaimer" className="hover:text-primary transition-colors">Disclaimer</Link></li>
            </ul>
          </div>

          <div className="space-y-2">
            <h4 className="text-md font-semibold text-foreground">Connect</h4>
            <p>Stay updated with our latest news and features.</p>
            <form className="flex items-center space-x-2 mt-2">
              <input
                type="email"
                placeholder="Your email"
                className="px-3 py-1 rounded border border-border bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                aria-label="Email for newsletter"
              />
              <button
                type="submit"
                className="bg-primary text-primary-foreground px-3 py-1 rounded text-sm font-semibold hover:bg-primary/90 transition-colors"
              >
                Subscribe
              </button>
            </form>
            <div className="flex space-x-3 mt-3">
              <a href="https://facebook.com/yourpage" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <div className="w-8 h-8 bg-primary rounded-xl flex items-center justify-center">
                  <svg className="h-4 w-4" fill="#fff" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.406.595 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.406 24 22.674V1.326C24 .592 23.406 0 22.675 0"/></svg>
                </div>
              </a>
              <a href="https://x.com/yourpage" target="_blank" rel="noopener noreferrer" aria-label="X">
                <div className="w-8 h-8 bg-primary rounded-xl flex items-center justify-center">
                  <svg className="h-4 w-4" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="12" fill="#14543a"/>
                    <path d="M12 12L28 28M28 12L12 28" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </a>
              <a href="https://linkedin.com/company/yourpage" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <div className="w-8 h-8 bg-primary rounded-xl flex items-center justify-center">
                  <svg className="h-4 w-4" fill="#fff" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11.75 20h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm15.25 11.268h-3v-5.604c0-1.337-.025-3.063-1.868-3.063-1.868 0-2.154 1.459-2.154 2.967v5.7h-3v-10h2.881v1.367h.041c.401-.761 1.381-1.563 2.844-1.563 3.042 0 3.604 2.003 3.604 4.605v5.591z"/></svg>
                </div>
              </a>
              <a href="https://youtube.com/yourpage" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <div className="w-8 h-8 bg-primary rounded-xl flex items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="12" fill="#14543a"/>
                    <polygon points="16,13 28,20 16,27" fill="#fff"/>
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-4 border-t border-border text-center">
          © {new Date().getFullYear()} Cricket Scoring. All rights reserved.
        </div>
      </div>
    </footer>
  );
}; 